module.exports = require("./de.js");